import React, { useState } from "react"
import { Card, CardBody, Col } from "reactstrap"
import PropTypes from "prop-types"

const Revenue = ({ data }) => {
  const [dataType, setDataType] = useState("monthly")
  let list = data[dataType]["carparks"] || { "test": 100 }

  const handleClick = type => {
    setDataType(type)
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <div className="d-flex flex-wrap">
            <div className="me-2">
              <h5 className="card-title mb-3">Revenue</h5>
            </div>
          </div>
          <div className="text-center row">
            <Col xs={6}>
              <a onClick={() => handleClick("monthly")}>
                <div className="mt-3">
                  <p className="text-muted mb-1">This Month</p>
                  <h5>
                    {`SGD ${data && (data["monthly"]?.total || 0).toFixed(2)}`}
                  </h5>
                </div>
              </a>
            </Col>
            <Col xs={6}>
              <a onClick={() => handleClick("yearly")}>
                <div className="mt-3">
                  <p className="text-muted mb-1">This Year</p>
                  <h5>
                    <sup>SGD</sup>{" "}
                    {data && (data["yearly"]?.total || 0).toFixed(2)}
                    {/* <span className="ms-2 text-success font-size-13">
                    12.0 %<i className="mdi mdi-arrow-up ms-1"></i>
                  </span> */}
                  </h5>
                </div>
              </a>
            </Col>
          </div>
          <hr />
          <div>
            <ul className="list-group list-group-flush">
              {Object.keys(list).map((key,index)  => {
                return (
                  <li className="list-group-item" key={`${key}`}>
                    <div className="py-2">
                      <h5 className="font-size-14">
                        {key || ""}
                        <span className="float-end">
                          {(list[key] || 0).toFixed(0)}
                          <small className="ms-1">SGD</small>
                        </span>
                      </h5>
                      <div className="progress animated-progess progress-sm">
                        <div
                          className="progress-bar bg-success"
                          role="progressbar"
                          aria-valuenow={list[key] || 0}
                          aria-valuemin="0"
                          aria-valuemax={data[dataType]?.total || 100}
                          style={{ width: (list[key]||0)*100/(data[dataType]?.total||100) + "%" }}
                        ></div>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

Revenue.propTypes = {
  data: PropTypes.object,
}

export default Revenue
